<template>
  <div
    class="grid content-center items-center justify-center justify-items-center h-[50vh] text-center"
    role="status">
    <Spinner size="lg" />
    <span class="sr-only">Signing you out</span>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import Spinner from '@/components/v2/Spinner.vue';

export default {
  name: 'Logout',
  components: { Spinner },
  async created() {
    sessionStorage.clear();
    try {
      await Auth.signOut();
    } catch (err) {
      // Amplify rejects with "Signout timeout fail" if the hosted-UI redirect hasn't torn
      // the page down within its hardcoded 3s. The session is already cleared and the
      // redirect still happens, so there is nothing to recover from here.
      console.warn('Sign out did not complete cleanly:', err);
    }
  },
};
</script>
